import React from 'react'
import './home.css'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'

export const ConfigureMicrosoftPage = ({ isAllowed }) => {
  return (
    <>
      <Navigation isAllowed={isAllowed} theme={THEMES.dark} />

      <section className='header-to-dark darker padding140-150 box-shadow' style={{ minHeight: 'calc(100vh - 277px)' }}>
        <div className='container860 config-article'>
          <h1 style={{ marginBottom: 30 }}>Configure Microsoft</h1>
          <p>
            Pen Protect sends phishing simulation emails, and without proper configuration, some of them may be blocked
            by <strong>Microsoft’s spam filters</strong>. This could negatively impact your campaign results.
          </p>
          <p>This guide outlines how to prevent such issues and ensure your campaigns run smoothly.</p>
          <h2>1) Create the bypass rule</h2>
          <p>
            To whitelist Pen Protect, you will need to add the IP address we use to send emails. Go to Exchange admin
            center and open <strong>Mail flow &gt; Rules</strong>.
          </p>
          <img src='images/configure/microsoft-config-1.png' alt='' />
          <p>
            Now click the <strong>+ Add a rule &gt; Create a new rule</strong>.
          </p>
          <img src='images/configure/microsoft-config-2.png' alt='' />
          <p>
            The IP address we will use to send our emails is <strong>198.244.61.71</strong>. This IP address is
            <strong> dedicated to Pen Protect</strong> and won’t be used by any third parties.
          </p>
          <p>First, start by naming the rule: "Pen Protect bypass".</p>
          <img src='images/configure/microsoft-config-3.png' alt='' />
          <p>
            Then, you will need to apply this rule for the reserved IP address <strong>198.244.61.71</strong>. To do
            that, in the <strong>Apply this rule if…</strong> list, select The sender…
          </p>
          <img src='images/configure/microsoft-config-4.png' alt='' />
          <p>
            And then <strong>IP address is in any of these ranges or exactly matches</strong>.
          </p>
          <img src='images/configure/microsoft-config-5.png' alt='' />

          <p>
            Add IP <strong>198.244.61.71</strong> and save.
          </p>
          <img src='images/configure/microsoft-config-6.png' alt='' />
          <p>Then</p>
          <img src='images/configure/microsoft-config-7.png' alt='' />
          <img src='images/configure/microsoft-config-8.png' alt='' />
          <p>You should have a rules like this:</p>
          <img src='images/configure/microsoft-config-9.png' alt='' />
          <p>
            Then click<strong> Next -&gt; Next -&gt; Finish.</strong>
          </p>
          <p>
            The rule has been created. <strong>Don’t forget to enable it</strong> — it is disabled by default
          </p>
          <h2>2) Add SkipSafeLinksProcessing header</h2>
          <p>
            From time to time, some links sent by Pen Protect might be flagged as suspicious. That’s why we suggest to
            add an additional header to prevent that from happening. To do that, add a rules like the previous one then:
          </p>
          <p>
            Select <strong>Modify the message properties…</strong> and then <strong>set a message header</strong>.
          </p>
          <img src='images/configure/microsoft-config-10.png' alt='' />
          <p>
            Then on the right, call the property <strong>X-MS-Exchange-Organization-SkipSafeLinksProcessing</strong>.
          </p>
          <img src='images/configure/microsoft-config-11.png' alt='' />
          <p>Set the value to 1.</p>
          <img src='images/configure/microsoft-config-12.png' alt='' />
          <p>You’re all set now, so don’t forget to Save the rule.</p>
          <p>You should have a rules like this:</p>
          <img src='images/configure/microsoft-config-13.png' alt='' />
          <p>
            Then click<strong> Next -&gt; Next -&gt; Finish.</strong>
          </p>
          <p>
            The rule has been created. <strong>Don’t forget to enable it</strong> — it is disabled by default.
          </p>
          <h2>3) Add BypassClutter header</h2>
          <p>
            Some organizations give their employees the option to use a “Clutter Folder” in newer versions of Outlook
            and Exchange. Add another rule like the previous one with:
          </p>
          <p>
            {' '}
            • property: <strong>X-MS-Exchange-Organization-BypassClutter</strong>
          </p>
          <p> • value: 1</p>
          <img src='images/configure/microsoft-config-14.png' alt='' />
          <p>
            Then click<strong> Next -&gt; Next -&gt; Finish.</strong>
          </p>
          <p>
            The rule has been created. <strong>Don’t forget to enable it</strong> — it is disabled by default.
          </p>
          <h2>4) Activate the Phishing simulation feature</h2>
          <p>
            Microsoft released recently an additional setting that makes it very easy to whitelist Pen Protect emails.
            Go to the "Advanced delivery options" and <strong>click on Edit</strong>.
          </p>
          <img src='images/configure/microsoft-config-15.png' alt='' />
          <p>It will open a side panel. In there, you will have to enter both the domain names</p>
          <ul>
            <li>auto-reply.link</li>
            <li>atlassian-no-reply.com</li>
            <li>auto-invoicing.com</li>
            <li>auto-response.com</li>
            <li>aws-cloud.co</li>
            <li>penprotect.ai</li>
            <li>norpl.co</li>
            <li>authlnk.com</li>
            <li>authlnk.net</li>
            <li>email-zendesk.com</li>
            <li>gitlab.email</li>
            <li>google-work.space</li>
            <li>google-workspace.com.pl</li>
            <li>microsoft-no-reply.com</li>
            <li>no-reply.com.pl</li>
            <li>office365noreply.com</li>
          </ul>
          <p>
            we use to send phishing emails and the IP address <strong>198.244.61.71</strong>. Finally, add the domains
            hosting our phishing pages.
          </p>
          <p>*.norpl.co/*</p>
          <p>*.authlnk.com/*</p>
          <p>*.authlnk.net/*</p>
          <img src='images/configure/microsoft-config-16.png' alt='' />
          <p>Once added, click on Save</p>
          <h2>5) Modify the block/allow list</h2>
          <p>
            To fully allow emails sent from our sending IP, we need to add one last parameter, for this go to this page
            and click on <strong>Add</strong>.
          </p>
          <img src='images/configure/microsoft-config-17.png' alt='' />
          <p>
            This will open a side panel. You must enter the following information *, <strong>198.244.61.71</strong>
          </p>
          <p>This allows all senders from Pen Protect sending IP to be authorized.</p>
          <img src='images/configure/microsoft-config-18.png' alt='' />
          <p>
            Once added, click on <strong>Add</strong> and here we go!
          </p>
          <h2>6) Add Pen Protect phishing page URL to Safe Links</h2>
          <p>
            To avoid blocking our Pen Protect phishing urls by Microsoft Defender, We need to add a configuration in
            <strong>Safe Links</strong>, go to this page and click on <strong>Create</strong>.
          </p>
          <p>If the page is blank, you probably don't have Microsoft Defender and you can skip this step.</p>
          <img src='images/configure/microsoft-config-19.jpg' alt='' />
          <p>
            Once clicked, a page opens, you will have to pick a name for your safe links policy, eg. "Pen Protect Safe
            links Policy"
          </p>
          <p>
            Add the audience you want to send phishing emails to in the next section, It can be users, groups or
            domains.
          </p>
          <p>Then, take some time to carefully follow those settings in the picture below 👇</p>
          <img src='images/configure/microsoft-config-20.jpg' alt='' />
          <p>Click on "Manage URLS" and add the domains</p>
          <p>*.norpl.co/*</p>
          <p>*.authlnk.com/*</p>
          <p>*.authlnk.net/*</p>
          <p>
            Then click "next" and choose <strong>default</strong> for notification.
          </p>
          <p>Then click "next" and "finish".</p>
          <h2>
            <p>7) Try it out</p>
          </h2>
          <p>
            Now that you have configured Microsoft Outlook to receive Pen Protect emails,{' '}
            <strong>go back to the platform</strong> and test the configuration.
          </p>
          <p>
            Please note:{' '}
            <strong>
              Please note: the configuration may take a few minutes to propagate. If everything is well configured and
              you encounter a problem, wait 10 minutes and try again Please note:{' '}
            </strong>
            .
          </p>
          <p>
            Unfortunately, Microsoft 365 still occasionally scans emails, and even after setting up all the rules
            described above, some emails may still end up in quarantine. Therefore, please check the quarantine page
            from time to time at https://security.microsoft.com/quarantine to see if any emails have been caught.
          </p>
          <p>
            If you find any emails there, select them and click <strong>Release -&gt; Mark as false positive</strong>.
          </p>
        </div>
      </section>
      <Footer isAllowed={isAllowed} theme={THEMES.dark} />
    </>
  )
}
